export default "__VITE_ASSET__CK$lFKeq__"